import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import theme from '../LayoutComponents/theme';

const ArrowTarget = ({ score }) => {
    const width = 400;
    const height = 200;

    // Map score to ring Y position (SVG coordinates)
    let targetY;
    if (score >= 80) targetY = 100;
    else if (score >= 60) targetY = 85;
    else if (score >= 40) targetY = 60;
    else targetY = 30; // red ring

    const targetXCenter = 300;
    const leftHalfOffset = -70;
    const targetX = targetXCenter + leftHalfOffset;

    const getTargetColor = () => {
        return Number(score) >= 60
            ? theme.colors.green
            : Number(score) >= 40
                ? theme.colors.yellow
                : "red";
    };

    const getMatchMessage = () => {
        if (score >= 60) return "Great Match!";
        else if (score >= 40) return "Good Match";
        return "Match";
    };

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                overflow: 'hidden',
                flexDirection: 'column',
            }}

        >
            {/* Match message */}
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 2 }}
            >
                <Typography variant="h4" sx={{ fontWeight: theme.typography.fontWeightBold, color: getTargetColor(), mr:'10rem' }}>
                    {getMatchMessage()}
                </Typography>
            </motion.div>
            {/* Target */}
            <motion.div
                style={{
                    width: 200,
                    height: 200,
                    perspective: 1000,
                    position: 'absolute',
                    right: 20,
                }}
                initial={{ rotateY: 90 }}
                animate={{ rotateY: 0 }}
                transition={{ duration: 1, delay: 1.5 }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'transparent',
                        transformStyle: 'preserve-3d',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            transform: 'rotateY(0deg)',
                            backfaceVisibility: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <svg width="100%" height="100%" viewBox="0 0 200 200">
                            {/* Bullseye rings */}
                            <circle cx="100" cy="100" r="90" fill="red" />
                            <circle cx="100" cy="100" r="60" fill={theme.colors.yellow} />
                            <circle cx="100" cy="100" r="30" fill={theme.colors.green} />
                        </svg>
                    </Box>
                </Paper>
            </motion.div>

            {/* Arrow moving from left to left-half of target */}
            <motion.svg
                width={width}
                height={height}
                style={{ position: 'absolute', left: 0, top: 0, overflow: 'visible' }}
            >
                <motion.g
                    initial={{ x: 0, y: targetY }}
                    animate={{ x: targetX, y: targetY }}
                    transition={{ duration: 1.5, ease: 'easeOut' }}
                >
                    {/* Arrow shaft */}
                    <line x1={0} y1={0} x2={30} y2={0} stroke="#000" strokeWidth="3" />
                    {/* Arrowhead */}
                    <polygon points="30,-5 30,5 40,0" fill="#000" />
                </motion.g>
            </motion.svg>


        </Box>
    );
};

export default ArrowTarget;
